import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = partNumberStyles;

const ProductDetailsPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.productNumber) {
        return null;
    }

    const isCmiProduct = product.properties["isCmiProduct"]?.toLowerCase() === "true";
    const cmiPartNumber = product.detail?.name ? product.detail.name : product.properties["cmiIewcMaterial"];

    return (
        <>
            {/* Verndale Custom Feature - Show Customer Material # if product is CMI */}
            {isCmiProduct && (
                <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsCMIPartNumber">
                    <Typography {...styles.labelText}>{translate("Customer Material #")}:</Typography>{" "}
                    {product.detail?.modelNumber ?? product.detail?.name ?? product.productNumber}
                </Typography>
            )}

            {/* Verndale Custom Feature - Show IEWC Part # */}
            <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsIEWCPartNumber">
                <Typography {...styles.labelText}>{siteMessage("IEWC_Part_#")}:</Typography>{" "}
                {isCmiProduct && cmiPartNumber ? cmiPartNumber : product.productNumber}
            </Typography>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumber),
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
